module.exports = __webpack_public_path__ + "static/media/5.8d7720ad.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/5.mp3
// module id = 84
// module chunks = 0